import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useParams, useHistory } from 'react-router-dom'
import useBeforeUnload from 'Hooks/useRouteBeforeUnload'
import {
  useRecoilCallback,
  useRecoilState,
  useRecoilValue,
  useResetRecoilState
} from 'recoil'

import { pageState, formValidState } from './recoil/state/page'
import { modalDelete } from './recoil/state/modals'
import {
  deleteMessageCallback,
  resetStateCallback,
  saveMessageCallback
} from './recoil/callbacks/callbacks'

import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  Loading,
  Flex,
  FlexItem,
  Panel
} from 'mailup-web-components'

import ModalConfirmLeave from 'Components/ModalConfirmLeave'
import ErrorFeedback from 'Components/ErrorFeedback'
import Header from './Header'
import InputSubject from './components/InputSubject'
import InputNotes from './components/InputNotes'
import InputUrl from './components/InputUrl'
import InputFile from './components/InputFile'
import MessageBoxError from './components/MessageBoxError'
import MessageBoxWarning from './components/MessageBoxWarning'
import { ModalDelete } from './components/Modals/ModalDelete'
import { TYPE_FILE, TYPE_URL } from './const'
import PageContainer from 'Components/PageContainer'

const MessageCreate = () => {
  const intl = useIntl()

  const { type } = useParams()
  const history = useHistory()

  const saveMessage = useRecoilCallback(saveMessageCallback, [])
  const deleteMessage = useRecoilCallback(deleteMessageCallback, [])
  const resetState = useRecoilCallback(resetStateCallback, [])

  const resetPageState = useResetRecoilState(pageState)
  const resetModalState = useResetRecoilState(modalDelete)

  const isValidForm = useRecoilValue(formValidState)
  const [
    {
      pageType,
      error,
      severity,
      warning,
      isDirty,
      loading,
      response,
      success,
      boxError
    },
    setPageState
  ] = useRecoilState(pageState)
  const [{ show }, setModalState] = useRecoilState(modalDelete)
  // alert di uscita dalla pagina senza salvare
  useBeforeUnload(isDirty)
  // reset stati di pagina su unload
  useEffect(() => {
    return () => {
      resetPageState()
      resetModalState()
    }
  }, [])

  const handleCancel = () => {
    setModalState(prev => ({
      ...prev,
      show: false
    }))
  }

  const handleConfirm = () => {
    deleteMessage(response.IdMessage)
  }

  useEffect(() => {
    setPageState(prev => ({
      ...prev,
      pageType: type
    }))
  }, [type])

  useEffect(() => {
    if (success) {
      const route = `/messages/email/${response.IdMessage}/overview?source=EmailMessages&op=mod`
      history.push(route)
    }
  }, [success])

  return (
    <>
      <ModalDelete
        show={show}
        handleConfirm={handleConfirm}
        handleCancel={handleCancel}
      />
      <ModalConfirmLeave isDirty={isDirty} />

      <Loading
        open={loading}
        text={intl.formatMessage({
          id: 'Load.EmailMessageImport.ImportAndScanning'
        })}
      />
      <Header />

      <PageContainer>
        {error && (
          <ErrorFeedback
            error={intl.formatMessage({
              id: 'Load.EmailMessageImport.GenericError1'
            })}
            severity={severity}
            onClickReload={resetState}
            realodPage='Load.EmailMessageImport.GenericError2Link'
          />
        )}

        {!error && (
          <>
            <Flex flexDirection='column' width='100%'>
              {boxError && (
                <FlexItem margin='0 0 16px 0' width='100%'>
                  <MessageBoxError />
                </FlexItem>
              )}
              {warning && (
                <FlexItem margin='0 0 16px 0' wifth='100%'>
                  <MessageBoxWarning />
                </FlexItem>
              )}
            </Flex>
            <Panel collapsible={false} data-mu-test={`message-create-${type}`}>
              <Flex>
                <FlexItem flex='1' margin='0 16px 0 0'>
                  <InputSubject />
                </FlexItem>
                <FlexItem flex='1' margin='0 0 0 16px'>
                  <InputNotes />
                </FlexItem>
              </Flex>
              <Flex margin='16px 0 0 0'>
                <FlexItem flex='1' width='100%'>
                  {pageType === TYPE_URL && <InputUrl />}
                  {pageType === TYPE_FILE && <InputFile />}
                </FlexItem>
              </Flex>
            </Panel>

            <Button
              kind={BUTTON_VARIANT_PRIMARY}
              disabled={!isValidForm || (response && warning)}
              onClick={saveMessage}
            >
              {intl.formatMessage({ id: 'Load.MailupCommon.Save' })}
            </Button>
          </>
        )}
      </PageContainer>
    </>
  )
}

export default MessageCreate
